import React, { useRef, useEffect } from "react";
import { Dialog as UI5Dialog, Bar, Button } from "@ui5/webcomponents-react";
import { cn } from "../../../lib/cn";

export function Dialog({
  className,
  open,
  onClose,
  onAfterClose,
  headerText,
  header,
  footer,
  state = "None",
  maxWidth,
  children,
  ...props
}) {
  const dialogRef = useRef(null);

  const dialogHeader =
    header ||
    (headerText && (
      <Bar
        startContent={
          <span className="font-semibold text-lg">{headerText}</span>
        }
      />
    ));

  // Map maxWidth to Tailwind classes
  const maxWidthClass = maxWidth ? `max-w-${maxWidth}` : "";

  // Handle close event - prioritize onClose, fallback to onAfterClose
  const handleClose = onClose || onAfterClose;

  // Add click listener for backdrop
  useEffect(() => {
    if (!open || !handleClose) return;

    const timer = setTimeout(() => {
      const dialogElement = dialogRef.current;
      if (dialogElement) {
        // Access the shadow root to find the backdrop
        const shadowRoot = dialogElement.shadowRoot;
        if (shadowRoot) {
          const backdrop = shadowRoot.querySelector(".ui5-block-layer");
          if (backdrop) {
            backdrop.style.cursor = "pointer";
            backdrop.addEventListener("click", handleClose);
          }
        }
      }
    }, 100);

    return () => {
      clearTimeout(timer);
      const dialogElement = dialogRef.current;
      if (dialogElement?.shadowRoot) {
        const backdrop =
          dialogElement.shadowRoot.querySelector(".ui5-block-layer");
        if (backdrop) {
          backdrop.removeEventListener("click", handleClose);
        }
      }
    };
  }, [open, handleClose]);

  return (
    <UI5Dialog
      ref={dialogRef}
      open={open}
      onAfterClose={handleClose}
      header={dialogHeader}
      footer={footer && <Bar endContent={footer} />}
      state={state}
      className={cn(maxWidthClass, className)}
      style={maxWidth ? { width: "100%" } : undefined}
      {...props}
    >
      <div className="p-4">{children}</div>
    </UI5Dialog>
  );
}
